// Module
var code = "<div class=\"fc-stats-container__wrapper\" data-bind=\"style: {\n  '--fc-stats-space': padding + 'px'\n}\">\n  <!-- ko using: $parent -->\n  <!-- ko template: { nodes: $componentTemplateNodes } -->\n\n  <!-- /ko -->\n  <!-- /ko -->\n</div>\n";
// Exports
module.exports = code;